  import React, { useState, useEffect } from "react";
  import Popup from "reactjs-popup";
  import { FaEdit, FaPlus, FaTrash } from "react-icons/fa";
  import axios from "axios";

  function ModalMEImage({ label = "", refresh }) {
    const [open, setOpen] = useState(false);
    const [content, setContent] = useState([]);

    const toggleModal = () => {
      setOpen(!open);
      if (!open) fetchImages(); // Fetch data when modal opens
    };

    const fetchImages = () => {
      axios.get("/api/ME_images")
        .then((response) => {
          const data = response.data.map((item) => ({
            _id: item._id,
            name: item.name || "",
            designation: item.designation || "",
            file: null,
            fileName: item.fileName || item.name || "image.png"
          }));
          setContent(data);
        })
        .catch((err) => console.error("Error fetching images:", err));
    };

    const handleChange = (index, field, value) => {
      const newContent = [...content];
      newContent[index][field] = value;
      setContent(newContent);
    };

    const addNewField = () => {
      setContent([
        ...content,
        { name: "", designation: "", file: null, fileName: "" }
      ]);
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const uploadPromises = content.map(async ({ _id, name, designation, file }) => {
          if (!name || !designation) return;

          const formData = new FormData();
          formData.append("name", name);
          formData.append("designation", designation);
          if (file) {
            formData.append("image", file);
          }

          if (_id) {
            await axios.put(`/api/ME_upload/${_id}`, formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
          } else {
            await axios.post("/api/ME_upload", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            });
          }
        });

        await Promise.all(uploadPromises);
        alert("Data saved successfully!");
        toggleModal();
        if (refresh) refresh(); // Refresh parent state
      } catch (err) {
        console.error("Save error:", err);
        alert("Failed to save one or more entries.");
      }
    };

    const handleDelete = async (id, index) => {
      if (window.confirm("Are you sure you want to delete this image?")) {
        try {
          await axios.delete(`/api/ME_images/${id}`);
          const newContent = [...content];
          newContent.splice(index, 1);
          setContent(newContent);
          alert("Image deleted successfully");
          if (refresh) refresh(); // Refresh parent state
        } catch (err) {
          console.error("Error deleting image:", err);
          alert("Failed to delete image.");
        }
      }
    };

    return (
      <div className="modalDiv">
        <FaEdit className="icon-button" onClick={toggleModal} />

        <Popup
          className="editModal"
          open={open}
          closeOnDocumentClick={false}
          contentStyle={{
            overflowY: 'auto',
            maxHeight: '80vh',
            padding: '20px',
            width: '500px',
          }}
        >
          <a className="close" onClick={toggleModal}>&times;</a>
          <h3>Upload Profiles</h3>

          <form onSubmit={handleSubmit}>
            {content.map((item, index) => (
              <div key={index} className="upload-row" style={{ marginBottom: '15px' }}>
                <input
                  type="text"
                  placeholder="Name"
                  value={item.name}
                  onChange={(e) => handleChange(index, "name", e.target.value)}
                  required
                />
                <input
                  type="text"
                  placeholder="Designation"
                  value={item.designation}
                  onChange={(e) => handleChange(index, "designation", e.target.value)}
                  required
                />

                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <label htmlFor={`file-upload-${index}`} style={{
                    backgroundColor: '#f0f0f0',
                    padding: '6px 12px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    border: '1px solid #ccc',
                  }}>
                    Choose File
                  </label>

                  <span style={{ fontSize: '12px', color: '#555' }}>
                    {item.fileName || 'No file chosen'}
                  </span>

                  <input
                    id={`file-upload-${index}`}
                    type="file"
                    accept="image/*"
                    style={{ display: 'none' }}
                    onChange={(e) => {
                      handleChange(index, "file", e.target.files[0]);
                      handleChange(index, "fileName", e.target.files[0]?.name || item.fileName);
                    }}
                  />
                </div>

                {item._id && (
                  <button
                    type="button"
                    onClick={() => handleDelete(item._id, index)}
                    style={{
                      backgroundColor: 'red',
                      color: 'white',
                      border: 'none',
                      padding: '5px 10px',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      marginTop: '10px',
                    }}
                  >
                    <FaTrash />
                  </button>
                )}
              </div>
            ))}

            <FaPlus onClick={addNewField} className="icon-button" style={{ cursor: 'pointer', marginTop: '10px' }} />
            <button type="submit" style={{ marginTop: '15px' }}>Submit</button>
          </form>
        </Popup>
      </div>
    );
  }

  export default ModalMEImage;
